import {px} from '@pleo-io/telescope'

export const navigationOffset = px(55)
